/**
 * Created by jv on 09/11/2017.
 */
//js
const Shared = require("Sources/shared");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const ShoppingCartController = require("Sources/controllers/shopping-cart-controller");
const UserServices = require("Sources/services/user-services");
const FormValidator = require("Sources/components/form-validator");

//Styles
require("Styles/pages/contact.scss");

$(function()
{
  Shared.init();

  ContactPage.beforeInit(function(error)
  {
    if(error)
    {
      log.error("CreateGamePage::beforeInit failed: %o", error);

      Shared.Dialog.showMessageDialog({
        title: error.readableErrorTitle,
        message: error.readableErrorMessage
      });
    }

    ContactPage.init();
  });
});

var ContactPage = {};

((ContactPage) =>
{
  var shoppingCart;

  var contactFormValidator = null;

  ContactPage.init = function()
  {
    Shared.setUpLoginNavBar({
      appendTo: "#login-navbar",
      user: Shared.getUserData(),
      shoppingCart: shoppingCart,
      breadcrumbs: []
    });

    setUpEventListeners();
  };

  function setUpEventListeners()
  {
    contactFormValidator = new FormValidator({
      selector: "#contact-form",
      validateOnChange: true,
      rules: {
        name: { required: true },
        email: { required: true },
        message: { required: true }
      }
    });

    $("#contact-submit-btn").on("click", function(e)
    {
      var $this = $(this);
      var isValid = contactFormValidator.validate();

      if(isValid)
      {
        $this.prop("disabled", true).removeClass("loading").addClass("loading");

        var formData = contactFormValidator.getFormData();

        sendContactForm(formData.name, formData.email, formData.message, function(err, data)
        {
          $this.prop("disabled", false).removeClass("loading");

          if(err)
          {
            Shared.Dialog.showMessageDialog({
              title: data.readableErrorTitle,
              message: data.readableErrorMessage
            });

            return;
          }

          Shared.Dialog.showMessageDialog({
            title: "contact.submit.success.dialog.title",
            message: "contact.submit.success.dialog.message"
          });
        });
      }
    });
  }

  function sendContactForm(name, email, message, callback)
  {
    UserServices.sendContactForm(name, email, message,
      function(data)
      {
        if(utils.isFunction(callback))
        {
          callback(false, data);
        }
      },
      function(data)
      {
        log.error("Failed to send contact form");

        if(utils.isFunction(callback))
        {
          callback(true, data);
        }
      }
    );
  }

  ContactPage.beforeInit = function(callback)
  {
    var fetchedShoppingCart = false;

    ShoppingCartController.getShoppingCart(function(error, data)
    {
      if(error)
      {
        log.error("Failed to fetch shopping cart\nerror: %o\ndata: %o", error, data);
        errorCallback(error);
        return;
      }

      shoppingCart = data;
      fetchedShoppingCart = true;
      checkFinished();
    });

    function errorCallback(error)
    {
      if(utils.isFunction(callback))
      {
        callback(error);
      }
    }

    function checkFinished()
    {
      if(fetchedShoppingCart && utils.isFunction(callback))
      {
        callback(false);
      }
    }
  };
})(ContactPage);



// WEBPACK FOOTER //
// ./app/js/entries/contact.js